module.exports = __webpack_public_path__ + "static/media/TATAMOTORS.9257815a.txt";